"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _default = function _default(_ref) {
  var onClick = _ref.onClick,
      onClose = _ref.onClose;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center text-sm py-1 bg-secondary"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-2 opacity-50"
  }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
    fontSize: "small"
  })), /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "search.moreIn.tips"
  }, "Some messages in Trash or Spam match your search.", /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-primary font-semibold",
    onClick: onClick
  }, "View messages"), "."), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-2"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "opacity-50 hover:opacity-100",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    fontSize: "small"
  }))));
};

exports["default"] = _default;
//# sourceMappingURL=MoreInTips.js.map